import { IAnimationControllerConfiguration, Inject, Key, GameRandom } from "@denishussar/html5-game-engine";
import { GameLogic } from "../../Logic/GameLogic";
import { KykkaModel } from "../../Models/KykkaModel";
import { IPlayerControllerOptions, PlayerController } from "./PlayerController";
import { IFieldSize } from "../../Constants/FieldSizesConstants";
import { DifficultyConstants } from "../../Constants/DifficultyConstants";
import { ConverUnitHelpers } from "../../Helpers/Helpers";
import { KykkaState } from "../../Constants/KykaState";
interface QueueMovementItem {
    x?: number,
    angleX?: number,
    angleY?: number,
    power?: number,
    time: number,
    _elapsed: number,
    _power0?: number,
    _x0?: number,
    _angleX0?: number
    _angleY0?: number,
    _callback?: Function
}

export class AIPlayerController extends PlayerController{
    private _active = false;
    private _movementQueue: QueueMovementItem[] = [];
    private _kykkaItems: KykkaModel[] = [];

    public constructor(
        @Inject protected _options: IPlayerControllerOptions,
        @Inject protected _gameLogic: GameLogic,
        @Inject private _random: GameRandom,
    ) {
        super(_options, _gameLogic);
        console.log('AIPlayerController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        const config = super.getConfiguration();
        return {
            ...config,
            onPointerDown: (e) => {

            },
            onPointerUp: () => {

            },
            onPointerUpOutside: () => {

            },
            onPointerMove: (e) => {

            }
        };
    }

    protected onInitialize(): void {
        super.onInitialize();
        // this._movementQueue.push({
        //     x: -400,
        //     time: 2,
        //     _x0: this.x,
        //     _elapsed: 0,
        //     _callback: () => {
        //         // TODO: переместить в логику создания очереди
        //         const angle = this._calcThrownAngle();
        //         const power = this._random.float(0.5, 0.65);
        //         this._movementQueue.push({
        //             angleX: power * Math.cos(angle),
        //             angleY: -power * Math.sin(angle),
        //             power: -power,
        //             time: 1,
        //             _angleX0: 0,
        //             _angleY0: 0,
        //             _power0: 0,
        //             _elapsed: 0
        //         });
        //     }
        // });

        // this._movementQueue.push({
        //     x: 100,
        //     time: 1,
        //     _x0: 200,
        //     _elapsed: 0
        // });
    }

    public setKykkas(list: KykkaModel[]) {
        this._kykkaItems = list;
    }

    public run() {
        this._generateMovement();
        this._active = true;
    }

    protected onUpdate(frameRate: number): void {
        if (this._active && this._movementQueue.length) {
            const queueItem = this._movementQueue[0];
            const isFirstUpdate = !queueItem._elapsed;
            queueItem._elapsed += frameRate;

            const percent = Math.min(1, queueItem._elapsed / queueItem.time);
            if (queueItem.hasOwnProperty('x')) {
                this._gameLogic.setPlayerX(queueItem._x0 + (queueItem.x - queueItem._x0) * percent);
                if (isFirstUpdate) {
                    if (queueItem.x < queueItem._x0 ) {
                        this._dbPlayer.moveLeft();
                    } else {
                        this._dbPlayer.moveRight();
                    }
                }
            }

            if (queueItem.hasOwnProperty('angleX')) {
                // console.log('AIPlayerController:onUpdate', percent, queueItem._angleX0 + (queueItem.angleX - queueItem._angleX0) * percent);
                this._gameLogic.setPlayerAngle(
                    queueItem._angleX0 + (queueItem.angleX - queueItem._angleX0) * percent,
                    queueItem._angleY0 + (queueItem.angleY - queueItem._angleY0) * percent,
                );
            }

            if (queueItem.hasOwnProperty('power')) {
                this._gameLogic.setPlayerPower(queueItem._power0 + (queueItem.power - queueItem._power0) * percent);
                if(isFirstUpdate) {
                    this._gameLogic.directionChangeStart();
                }
            }

            if(percent === 1) {
                this._movementQueue.shift();
                if (queueItem.hasOwnProperty('x')) {
                    // queueItem._callback();
                    this._generateAngle();
                }
                this._dbPlayer.idle();

                if(!this._movementQueue.length) { // закончили очередь. Теперь кидаем
                    // if(this.$model.hits === 0 ) {
                        this._gameLogic.hitStart();
                    // }
                    this._active = false;
                }
            }
        }
    }

    private _calcThrownAngle() {
        let kykka;
        if(this.$model.kykkaTouched) {
            kykka = this.getBestKykka();
            console.log('_calcThrownAngle:kykka1', kykka);

        } else {
            // одна из 6 центральных кюкей
            // Нечетные стоят вторым рядом (сверху). Выбираем одну из четных отбросив по 4 справа и слева
            const targetIndex = Math.floor(this._random.integer(4, 0.5 * (this._kykkaItems.length - 4)) * 2);
            kykka = this._kykkaItems[targetIndex];
            // const angle = Math.atan2(this._kykkaItems[targetIndex].x - this.$model.x3d, this.$model.z3d) - 0.5 * Math.PI;
        }

        const angle = (0.5 * Math.PI - Math.atan2((-kykka.x - this.$model.x3d - 70), (this.$model.z3d)) );
        console.log('_calcThrownAngle:angle', angle * 180 / Math.PI, Math.atan2((kykka.x - this.$model.x3d), (this.$model.z3d))*180/Math.PI);
        return angle;
    }

    private getBestKykka() {
        // return this._kykkaItems[0];
        const sectors = this._kykkasInSerctors();
        const keys = Object.keys(sectors);
        // let max = 0;
        const max = Math.max(...keys.map(k => sectors[k].length));
        const sectorsWithMax = [];


        Object.keys(sectors).forEach((k) => {
            if (sectors[k].length === max ) {
                sectorsWithMax.push(sectors[k]);
            }
        });

        const targetSectorIndex = this._random.integer(0, sectorsWithMax.length);
        if (sectorsWithMax.length) {
            const kykkas = sectorsWithMax[targetSectorIndex];
            return kykkas[this._random.integer(0, kykkas.length)];
        }

        const guestKykka = this._kykkaItems[0];
        for (let index = 0; index < this._kykkaItems.length; index++) {
            if (this._kykkaItems[index].state === KykkaState.Guest) {
                return this._kykkaItems[index];
            }
        }
        return guestKykka;
    }

    private _kykkasInSerctors(): { [key: number]: KykkaModel[] } {
        const countObj = {};
        const z0 = this.fieldSize.distance;
        const z1 = this.fieldSize.distance + this.fieldSize.length;

        const sectorStep = 1000;
        const epsilon = 1;
        let sectorIndex = 0;
        for (let x = -0.5 * this.fieldSize.width; x < 0.5 * this.fieldSize.width; x += sectorStep) {
            for (let z = z0; z < z1; z += sectorStep) {
                countObj[sectorIndex] = [];

                for (let index = 0; index < this._kykkaItems.length; index++) {
                    const kykka = this._kykkaItems[index];
                    // console.log('kykka.z', kykka.z, z);

                    if (kykka.z >= z - epsilon
                        && kykka.z <= z + sectorStep + epsilon
                        && kykka.x >= x - epsilon
                        && kykka.x <= x + sectorStep + epsilon) {
                        // countObj[sectorIndex] = countObj[sectorIndex] || [] (countObj[sectorIndex] + 1) || 1;
                        countObj[sectorIndex].push(kykka);
                    }
                }
                sectorIndex++;
            }
        }
        console.log('_kykkasInSerctors', countObj);

        return countObj;
    }

    private _generateMovement() {
        const total = this._random.integer(1, 2);
        let prevX = this.x;
        for (let index = 0; index < total; index++) {
            // const x = this._random.integer(-560, 220);
            const width = 0.5 * this.fieldSize.width;
            const x = this._random.integer(ConverUnitHelpers.mmTo2D(-width), ConverUnitHelpers.mmTo2D(width)); // TODO: вынести в константы (еще используется в логике),
            console.log('_generateMovement', x, ConverUnitHelpers.mmTo2D(-width), ConverUnitHelpers.mmTo2D(width));

            this._movementQueue.push({
                x,
                time: Math.abs(x - prevX) / 150,
                _x0: prevX,
                _elapsed: 0
            });
            prevX = x;
        }
    }

    private _generateAngle() {
        let angle = this._calcThrownAngle();
        const power = this._random.float(0.55, 0.75);
        const sign = this._random.sign(0.5);
        let deltaDeg = 0;

        // если бот не попапл не по одной кюке в предыдущий бросок,
        // то он целится точнее
        // первый раз кидаем так с минимальной погрешностью
        if (!this.$model.scoresLog.length || this.$model.scoresLog[0].delta === 0)  {
            deltaDeg = 1;
        } else {
            switch (this.$model.difficulty) {
                case DifficultyConstants.Easy:
                    deltaDeg = sign * this._random.integer(8, 12);
                    break;
                case DifficultyConstants.Medium:
                    deltaDeg = sign * this._random.integer(5, 10);
                    break;
                case DifficultyConstants.Hard:
                    deltaDeg = sign * this._random.integer(0, 8);
                    break;
            }
        }
        angle += sign * deltaDeg * Math.PI / 180;;

        this._movementQueue.push({
            angleX: power * Math.cos(angle),
            angleY: power * Math.sin(angle),
            power: power,
            time: 1,
            _angleX0: 0,
            _angleY0: 0,
            _power0: 0,
            _elapsed: 0
        });
    }
}